var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-size-select"},[_c('input-field',_vm._b({attrs:{"min":"0","max":"500","step":"1","append":"px","small":"","type":"number"},on:{"input":_vm.onInput,"change":_vm.onChange},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=_vm._n($$v)},expression:"localValue"}},'input-field',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }